export default function(state = '1', action) {
  if  (action.type === 'nav') {
    // console.log('je suis dans nav', action.key);
    return action.key;
  }
  return state;
}